import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import {beautifyLocalTimeFromTimestamp, getCurrentTimezone} from '../../../../store/utility';

import classes from './CalendarSelection.css';

class CalendarInfo extends React.Component{

    componentDidMount() {
    }

    render(){

        let content = null;
        if (this.props.calendarBookingSelectedAvailability!=null){
            content = beautifyLocalTimeFromTimestamp(this.props.calendarBookingSelectedAvailability)
        }
        else {
            content = 'Please select a time'
        }

        return (
            <Container className={classes.CalendarSelectionBox}>
            <Row>
                <Col> Booking {this.props.calendarOwnerFirstName}</Col>
            </Row>
            <Row>
                <Col><b>{content}</b></Col>
            </Row>
            <Row>
                <Col> <span> ({getCurrentTimezone()}) </span> </Col>
            </Row>
          </Container>
        );
    }
}

export default CalendarInfo;


// WEBPACK FOOTER //
// ./src/containers/Schedule/UI/CalendarSelection/CalendarSelection.js